<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <template v-slot:activator="{ on }">
      <!-- <v-btn color="primary" dark v-on="on">Open Dialog</!-->
      <v-btn icon color="black" v-on="on">
        <v-icon>mdi-plus-thick</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title> New {{ AccountType }} Account </v-card-title>
      <v-card-text>
        Creating New {{ AccountType }} Account
        <v-container>
          <v-form ref="AccounForm">
            <v-text-field
              v-model="AccountName"
              :rules="[v => !!v || 'Accoount Name is required']"
              name="Expname"
              :label="`Enter ${AccountType} Name`"
              id="Expense_id"
            ></v-text-field>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :disabled="loading" @click="close" text
          >Cancel</v-btn
        >
        <v-btn color="success" :loading="loading" @click="OnSave" text
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    AccountType: { type: String, required: true },
    Display: { type: Function },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      AccountName: "",
    };
  },

  methods: {
    close() {
      this.dialog = false;
      this.$refs.AccounForm.reset();
    },
    OnSave() {
      if (this.$refs.AccounForm.validate()) {
        this.loading = true;
        let saveAccount;
        if (this.AccountType === "Cash")
          saveAccount = {
            AccountType: "Assets",
            category: this.AccountType,
            AccountName: this.AccountName,
          };
        else if (this.AccountType === "Expenses")
          saveAccount = {
            AccountType: this.AccountType,
            AccountName: this.AccountName,
          };
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/Accounts/NewAccount",
            data: { saveAccount },
          })
          .then(() => {
            this.Display();
            this.loading = false;
            this.close();

            // console.log(val);
          })
          .catch(() => {
            this.loading = false;
            // console.log(err);
          });
      }
    },
    created() {},
  },
};
</script>
